import { createSelector } from "@reduxjs/toolkit";

import { IApplicationState, WSelector } from "../rootInterface";

import { TLabelsCategory, TLabelsGroup } from "./types";

const selectState = (state: IApplicationState) => state.labelsGroup;

export const labelsGroupSelector = createSelector(
  selectState, labels => labels?.labelsGroup);
export const labelsGroupInfoSelector = createSelector(
  selectState, labels => labels?.labelsGroupInfo);
export const labelGroupCreateSelector = createSelector(
  selectState, labels => labels?.labelGroupCreate);

export const labelsGroupListSelector = createSelector(
  selectState, labels => labels?.labelsGroupList
);
export const importCSVCustomLabelSelector = createSelector(
  selectState, labels => labels?.importCSVCustomLabel
);
export const labelsEntityCategorySelector = createSelector(
  selectState, labels => labels?.labelsEntityCategory
);
export const labelsEntityCategorySelectorById = (id: string | undefined | null): WSelector<TLabelsCategory|undefined> =>
  createSelector(
    selectState,
    labels => {
      if (!id) return undefined;
      return labels.labelsEntityCategory.data?.results?.find(group => group.id === id);
    }
  );

export const labelsGroupSelectorById = (id: string | undefined | null): WSelector<TLabelsGroup|undefined> =>
  createSelector(
    selectState,
    labels => {
      if (!id) return undefined;
      return labels.labelsGroup.data?.results?.find(group => group.id === id);
    }
  );

export const labelsGroupLabelsEditFetchingSelector = createSelector(
  selectState,
  labels => labels?.labelsGroup?.fetching
);

export const createCustomLabelSelector = createSelector(
  selectState, labels => labels?.createCustomLabel
);

export const editCustomLabelSelector = createSelector(
  selectState, labels => labels?.editCustomLabel
);

export const entityCategoriesOverviewSelector = createSelector(
  selectState, labels => labels?.entityCategoriesOverview
);

export const makeLabelFetchingSelector = (id: string): WSelector<boolean|undefined> =>
  createSelector(
    selectState,
    labels => labels?.editCustomLabel?.fetchingById?.[id] || false
  );
